@for (signalConfig of gatewaySignals; track signalConfig; let i = $index) {
  <div>
    <div class="card card-default mb-2">
      <div [ngClass]="{'card-header-collapsed' : !isCollapsed[i]}" class="card-header card-header-hoverable" role="button"
        (click)="setCollapsingBehavior(i, true)">
        <div class="row align-items-center">
          <div class="col">
            <div class="row">
              <div class="col">
                <strong class="h6 card-title mb-0"
                [innerText]="signalConfig.typeOfData"></strong>
                <ng-template #HeaderValidationTooltip>
                  <span translate>There are duplicate Values.</span>
                </ng-template>
                @if (signalDuplicateAlias[i]) {
                  <span class="text-danger ml-1">
                    <em class="fa-solid fa-circle-exclamation" [ngbTooltip]="HeaderValidationTooltip"></em>
                  </span>
                }
                <ng-template #HeaderValidationTooltipInvalidChars>
                  <span translate>There are aliases containing invalid symbols.</span>
                </ng-template>
                @if (signalInvalidAlias[i]) {
                  <span class="text-danger ml-1">
                    <em class="fa-solid fa-circle-exclamation" [ngbTooltip]="HeaderValidationTooltipInvalidChars"></em>
                  </span>
                }
              </div>
              <div class="col-auto">
                @if (signalConfig.streamToBigTable) {
                  <span class="badge badge-pill badge-outline badge-success ml-2"
                    >
                    <span class="fa-solid fa-check mr-1"></span>
                    <span translate>BigTable streaming</span>
                  </span>
                }
                @if (!isEavViewFeatureEnabled && signalConfig.eavViewEnabled) {
                  <span class="badge badge-pill badge-outline badge-warning ml-2">
                    <span class="fa-solid fa-xmark mr-1"></span>
                    <span translate>EAV View Functionality disabled</span>
                  </span>
                }
                @if (isEavViewFeatureEnabled && signalConfig.eavViewEnabled) {
                  <span class="badge badge-pill badge-outline badge-success ml-2"
                    >
                    <span class="fa-solid fa-check mr-1"></span>
                    <span translate>EAV View Enabled</span>
                  </span>
                }
                @if (signalConfig.dataImputation) {
                  <span class="badge badge-pill badge-outline badge-success ml-2"
                    >
                    <span class="fa-solid fa-check mr-1"></span>
                    <span translate>Data Imputation enabled</span>
                  </span>
                }
                @if (signalConfig.streamEventDataToPubSub) {
                  <span class="badge badge-pill badge-outline badge-success ml-2"
                    >
                    <span class="fa-solid fa-check mr-1"></span>
                    <span translate>Stream event data to Pub/Sub</span>
                  </span>
                }
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div aria-label="..." class="pull-right" role="group">
              <input accept=".json,text/json" id="aliasConfigFileUpload" name="csvFile"
                style="visibility:hidden; position:absolute;"
                type="file"/>
                <span [attr.aria-expanded]="isCollapsed[i]"
                  class="btn btn-xs btn-outline-primary mr-2">
                  <em [ngClass]="{'fa-chevron-up' : isCollapsed[i], 'fa-chevron-down' : !isCollapsed[i]}" class="fa-solid"></em>
                </span>
                <scitis-gateway-aliases-action
                  (updatedConfig)="onImportConnectorConfig(signalConfig)"
                  (deleteAliasEmit)="onDeleteAlias(signalConfig)"
                  (openMaskEmit)="openMask(signalConfig, i)"
                  (fileSelectEvent)="onFileSelected($event)"
                  [signalConfig]="signalConfig"
                  [isEditable]="isEditable"
                  [superOrTechAdminRole]="superOrTechAdminRole">
                </scitis-gateway-aliases-action>
              </div>
            </div>
          </div>
        </div>
        <div [ngbCollapse]="!isCollapsed[i]" (ngbCollapseChange)="isCollapsed[i] = $event" class="card-body" role="tabpanel">
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <h5 class="h5 mb-3" translate>Settings</h5>
                @if (bigTableStreamingFeatureEnabled) {
                  <div class="form-check form-switch d-inline-flex">
                    <input (change)="aliasConfigChanged = true" [(ngModel)]="signalConfig.streamToBigTable"
                      [disabled]="!isEditable"
                      class="form-check-input"
                      id="checkStreamBigTable{{i}}"
                      type="checkbox"
                      role="switch">
                      <label class="form-check-label ms-2" for="checkStreamBigTable{{i}}" translate>BigTable streaming</label>
                    </div>
                  }
                  @if (isEavViewFeatureEnabled) {
                    <div class="form-check form-switch d-inline-flex ms-3">
                      <input (change)="aliasConfigChanged = true" [(ngModel)]="signalConfig.eavViewEnabled"
                        [disabled]="!isEditable" class="form-check-input"
                        id="checkEavView{{i}}"
                        type="checkbox"
                        role="switch">
                        <label class="form-check-label ms-2" for="checkEavView{{i}}" translate>EAV View Enabled</label>
                      </div>
                    }
                    @if (isArgosGateway) {
                      <div class="form-check form-switch d-inline-flex ms-3">
                        <input (change)="aliasConfigChanged = true" [(ngModel)]="signalConfig.dataImputation"
                          [disabled]="!isEditable" class="form-check-input"
                          id="checkDataImputation{{i}}"
                          type="checkbox"
                          role="switch">
                          <label class="form-check-label ms-2" for="checkDataImputation{{i}}" translate>Data Imputation
                          enabled</label>
                        </div>
                      }
                      @if (isArgosGateway && isStreamingEventDataToPubSubFeatureEnabled) {
                        <div
                          class="form-check form-switch d-inline-flex ms-3">
                          <input (change)="aliasConfigChanged = true" [(ngModel)]="signalConfig.streamEventDataToPubSub"
                            [disabled]="!isEditable" class="form-check-input"
                            id="checkStreamEventData{{i}}"
                            type="checkbox"
                            role="switch">
                            <label class="form-check-label ms-2" for="checkStreamEventData{{i}}" translate>Stream event data to
                            Pub/Sub</label>
                          </div>
                        }
                      </div>
                      <hr>
                        @if (isCollapsed[i]) {
                          <div class="form-group">
                            <h5 class="h5 mb-3" translate>Aliases</h5>
                            <table class="table table-signals table-hover vertical-align-middle mb-0">
                              <thead>
                                <tr>
                                  <th class="text-center" style="width: 40px;">
                                    <a (click)="activateAll(signalConfig.values)" class="check-all"
                                      title="{{'Activate all available values.' | translate}}">
                                      <span class="fa-solid fa-square-check"></span>
                                    </a>
                                  </th>
                                  <th (sort)="onColumnSort($event, signalConfig)" class="sortable" scope="col" sortable="name">
                                    <span translate>Name</span>
                                  </th>
                                  <th (sort)="onColumnSort($event, signalConfig)" class="sortable" scope="col" sortable="alias">
                                    <i class="fa-solid fa-pen mr-2" title="This column can be edited inline"></i>
                                    <span translate>Alias</span>
                                  </th>
                                  <th>
                                    <span translate>Datatype</span>
                                  </th>
                                  <th>
                                    <span translate>Writable</span>
                                  </th>
                                  @if (isArgosGateway) {
                                    <th>
                                      <span translate>Index</span>
                                    </th>
                                  }
                                  <th>
                                    <span translate>Cluster</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (value of signalConfig.values | paginate: paginateControlSettings; track value) {
                                  <tr>
                                    <ng-template #InfoTooltip>
                                      <dl class="info-list">
                                        <dt><span translate>Name</span>:</dt>
                                        <dd [innerText]="value.name"></dd>
                                        <dt><span translate>Datatype</span>:</dt>
                                        <dd [innerText]="value.datatype"></dd>
                                        <dt><span translate>Dimension</span>:</dt>
                                        <dd [innerText]="value.dimension"></dd>
                                        <dt><span translate>Description</span>:</dt>
                                        <dd [innerText]="value.description"></dd>
                                        <dt><span translate>Alias</span>:</dt>
                                        <dd [innerText]="value.alias"></dd>
                                        <dt><span translate>Writable</span>:</dt>
                                        <dd [innerText]="value.writable"></dd>
                                        @if (isArgosGateway) {
                                          <dt><span translate>Index</span>:</dt>
                                        }
                                        @if (isArgosGateway) {
                                          <dd [innerText]="value.index"></dd>
                                        }
                                        <dt><span translate>Cluster</span>:</dt>
                                        <dd [innerText]="value.cluster"></dd>
                                      </dl>
                                    </ng-template>
                                    <td class="text-center">
                                      @if (value.active === true) {
                                        <div (click)="onSetInactive(value, signalConfig.values)"
                                          aria-hidden="true"
                                          class="checked">
                                          <span class="fa-regular fa-square-check"></span>
                                        </div>
                                      }
                                      @if (value.active === false) {
                                        <div (click)="onSetActive(value, signalConfig.values)">
                                          <span class="fa-regular fa-square"></span>
                                        </div>
                                      }
                                    </td>
                                    <!--description of variable-->
                                    <td>
                                      <span [innerText]="value.name"></span>
                                      <span [ngbTooltip]="InfoTooltip" class="ml-1 text-info" placement="top">
                                        <i class="fa-solid fa-circle-info"></i>
                                      </span>
                                    </td>
                                    <td class="flex-cell">
                                      <span
                                        [ngClass]="{ 'status-danger': value.duplicated || value.invalidChars }"
                                        [ngbTooltip]="value.duplicated ? ValidationTooltip : (value.invalidChars ? ValidationTooltipInvalidChars: null)"
                                      class="status"></span>
                                      <!-- Template Inline Edit Focus Start -->
                                      <ng-template #ValidationTooltip>
                                        <span translate>The alias has to be unique</span>
                                      </ng-template>
                                      <ng-template #ValidationTooltipInvalidChars>
                                        <span translate>The alias should contain latin letters, numbers or underscores.</span>
                                      </ng-template>
                                      <div>
                                        <scitis-inline-edit-input-field (cancel)="onCancelAliasRow(value, signalConfig.values)"
                                          (edit)="onEditAliasRow(value)"
                                          (save)="onSaveAliasRow($event, value, signalConfig.values)"
                                          [fieldValueEditClass]="value.aliasEditClass"
                                          [isEditable]="isEditable" [type]="'text'"
                                          [value]="value.alias">
                                        </scitis-inline-edit-input-field>
                                      </div>
                                    </td>
                                    <td>
                                      <span [innerText]="value.datatype"></span>
                                    </td>
                                    <td>
                                      @if (value.writable === true) {
                                        <span class="fa-solid fa-check"></span>
                                      }
                                    </td>
                                    @if (isArgosGateway) {
                                      <td [innerText]="value.index"></td>
                                    }
                                    <td class="text-center">
                                      @if (value.cluster === true && isAllowedValueForClustering(value)) {
                                        <div (click)="onDeactivateClusterColumn(value)"
                                          aria-hidden="true"
                                          class="checked">
                                          <span class="fa-regular fa-square-check"></span>
                                        </div>
                                      }
                                      @if (value.cluster === false || !isAllowedValueForClustering(value)) {
                                        <div (click)="onActivateClusterColumn(value)"
                                          >
                                          <span class="fa-regular fa-square"></span>
                                        </div>
                                      }
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        }
                        <div class="row align-items-center">
                          <div class="col">
                            <scitis-ngx-pagination [id]="paginateControlSettings.id"
                              mainClass="justify-content-between"
                              itemsPerPageClass="col-7"
                              [itemsPerPage]="paginateControlSettings.itemsPerPage"
                              [itemsPerPageOptions]="itemsPerPageOptions"
                              (pageNumberChange)="handlePageChange($event)"
                              (itemsPerPageChange)="onItemsPerPageChange($event)">
                            </scitis-ngx-pagination>
                          </div>
                          <div #resultButtons class="col-auto col-save-btns">
                            <button class="btn btn-outline-primary"
                              (click)="initRestoreSavedChanges(signalConfig, i)">
                              <span translate>Cancel</span>
                            </button>
                            @if (superOrTechAdminRole && !isGeneric && !isArgosGateway) {
                              <button class="btn btn-primary ml-2"
                                [disabled]="saveAliasIsDisabled || signalDuplicateAlias[i] || signalInvalidAlias[i]"
                                (click)="onSaveAlias(i)">
                                <span translate>Save</span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
